<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">In memory of Mrs. Connie Davis, my high school English teacher, who always expected more from me.</p>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">And to Trace, Ross, Julia, Jenna, Ryan, and</p>
<p class="alignment-block-content alignment-block-content-left">Emma—you were always my wishes</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3bf379be